import formatDate from 'date-fns/format'

export function format(date) {
  return formatDate(new Date(date), 'MMM dd, yyyy')
}
